import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import { Row, Col } from 'antd';
import nextIcon from 'images/next_icon.png';
import rupeeIcon from 'images/rupeeIcon.png';
import correctIcon from 'images/correct_green_icon.png';
import { LayoutContext } from 'components/app-routes';
import { addAgentCode } from '__utils/common-utils';


const OuterCont = styled.div<CommonStyledComponentProps>`
  .alignCenter{
        align-items: center;

    }
`;

const UpiSteps: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

    useEffect(() => {
        SetLayoutProps({
            config: { title: 'UPI Payment' },
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Investment Cart', url: '/cart-review', isExternal: true }, { text: 'UPI Payment', url: '' } ],
            showCopyrightInfoForDesktop: true,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return <OuterCont isMobile={ isMobile }>
        <section>
            <div>
                <Row gutter={ 16 } style={ { justifyContent: 'center'} }>
                    <Col xs={ 24 }>
                        <Row>
                            <Col xs={ 4 } md={ 4 }><img src={ nextIcon } alt="next"/> </Col>
                            <Col xs={ 20 }>Go to UPI ID linked mobile app or Click on the notification from your UPI linked mobile app</Col>
                        </Row><br/>
                        <Row className="alignCenter">
                            <Col xs={ 4 } md={ 4 }><img src={ rupeeIcon } alt="pending"/> </Col>
                            <Col xs={ 20 }>Check pending transactions</Col>
                        </Row><br/>
                        <Row>
                            <Col xs={ 4 } md={ 4 }><img src={ correctIcon } alt="correct"/> </Col>
                            <Col xs={ 20 }>Complete the payment by selecting the bank and entering UPI PIN</Col>
                        </Row>

                    </Col>
                </Row>

            </div></section>
    </OuterCont>

}
export default UpiSteps;